<template>
  <div>
    <div style="margin-bottom:20px;">
			<h1 style="text-align:left;">首页底部文字管理</h1>
			<el-divider></el-divider>
		</div>

    <div>
      <div>
        <el-button type="text" :style="{display: visible}" @click="dialogFormVisible = true">添加内容</el-button>
        <el-dialog title="添加内容" :visible.sync="dialogFormVisible">
          <el-form :model="form">
						<el-form-item label="">
							<textarea v-model="form.info.content" rows='15' cols='60'></textarea>
						</el-form-item>  
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false;file_list = [];">取 消</el-button>
            <el-button type="primary" @click="addCarouse">提 交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <el-dialog title="修改底部文字" :visible.sync="modify_dialog">
			<el-form :model="form">
				<el-form-item label="">
					<textarea v-model="form.info.content" rows='15' cols='60'></textarea>
				</el-form-item>
					
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modify_dialog = false;">取 消</el-button>
				<el-button type="primary" @click="confirmModifyCarouse">修 改</el-button>
			</div>
		</el-dialog> 

    <el-table :data="tableData" style="width: 100%" stripe>
			<el-table-column label="id" width="180">
				<template slot-scope="scope">
					<span style="margin-left: 10px">{{ scope.row.id }}</span>
				</template>
			</el-table-column>
			<el-table-column label="内容" width="480">
				<template slot-scope="scope">{{scope.row.info.content}}</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="modify_carouse(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
  </div>  
</template>

<style scoped>

</style>

<script>
export default {
  name: 'foot_manage',
  data() {
    return {
      modify_dialog: false,
      dialogFormVisible: false,
      visible: '',
      tableData: [{
        id: 1,
        info: {
          content: "编辑"
        }
      }],
      form: {
				info: {
					content: null
				}
			} 
    }
  },
  methods: {
    modify_carouse: function(row){
      this.modify_dialog = true;
			this.form = row
    },
    // 修改
    confirmModifyCarouse() {
      var self = this;
			this.form.info = JSON.stringify(this.form.info);
      this.ajax("/footmanage.php", "patch", JSON.stringify(this.form), function(data) {
				self.modify_dialog = false;
				self.ajax("/footmanage.php", "get", null, function(data) {
					var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
				});
        self.$message({
          message: "修改成功",
          type: "success"
        });
      });
    },
    // 添加
    addCarouse() {
			var self = this;
			var subdata = self.form.info;
      this.ajax("/footmanage.php", "post", JSON.stringify(subdata), function(data) {
        self.dialogFormVisible = false;
        self.form.info.content = null;
        self.ajax("/footmanage.php", "get", null, function(data) {
					var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
					if(JSON.parse(data).length>0){
						self.visible = 'none';
					}else{
						self.visible = '';
					}
        });
        self.$message({
          message: "添加成功",
          type: "success"
        });
      });
		}
  },
  mounted() {
    var self = this;
    this.ajax("/footmanage.php", "get", null, function(data) {
			var tableData = JSON.parse(data);
			for(let i=0;i<tableData.length;i++){
				tableData[i].info = JSON.parse(tableData[i].info);
			}
			self.tableData = tableData;
			if(JSON.parse(data).length>0){
				self.visible = 'none';
			}else{
				self.visible = '';
			}
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/foot_manage.vue